import { render, staticRenderFns } from "./ContentEditorBlock.vue?vue&type=template&id=a0f1d5e4&"
import script from "./ContentEditorBlock.vue?vue&type=script&lang=js&"
export * from "./ContentEditorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports